export default "__VITE_ASSET__DuZItLJI__"